import { render, staticRenderFns } from "./dialog-secondary.vue?vue&type=template&id=547ff217&scoped=true&"
import script from "./dialog-secondary.vue?vue&type=script&lang=js&"
export * from "./dialog-secondary.vue?vue&type=script&lang=js&"
import style0 from "./dialog-secondary.vue?vue&type=style&index=0&id=547ff217&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ff217",
  null
  
)

export default component.exports